/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { EntityVersion, ID } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const SpecTemplateParagraphIs = createEnum('SPEC_TEMPLATE_PARAGRAPH_IS', {
  Optional: 0,
  Mandatory: 1,
});
export type SpecTemplateParagraphIs = EnumSet<typeof SpecTemplateParagraphIs>;

export const SpecTemplateSectionIs = createEnum('SPEC_TEMPLATE_SECTION_IS', {
  Optional: 0,
  Mandatory: 1,
});
export type SpecTemplateSectionIs = EnumSet<typeof SpecTemplateSectionIs>;

export const SpecTemplateTextIs = createEnum('SPEC_TEMPLATE_TEXT_IS', {
  Optional: 0,
  Mandatory: 1,
  NotAllowed: 2,
});
export type SpecTemplateTextIs = EnumSet<typeof SpecTemplateTextIs>;

export const SpecTemplateClauses = createEnum('SPEC_TEMPLATE_CLAUSES', {
  NotAllowed: 0,
  Allowed: 1,
});
export type SpecTemplateClauses = EnumSet<typeof SpecTemplateClauses>;

export const SpecTemplateStatus = createEnum('SPEC_TEMPLATE_STATUS', {
  Deleted: 0,
  Active: 1,
});
export type SpecTemplateStatus = EnumSet<typeof SpecTemplateStatus>;

export type JobSpecTemplateFilterDto = {
  showDeleted?: boolean;
  searchString?: string;
  isForRfq?: boolean;
  sourceOfficeId?: ID;
};

export type JobSpecTemplateListItemDto = WithOptimisticLock<{
  id: ID;
  name: string;
  isForRfq: boolean;
  status: string;
  statusValue: SpecTemplateStatus;
  version: EntityVersion;
}>;

export type JobSpecTemplateDetailsDto = {
  specTemplateId?: ID;
  name: string;
  memo: string;
  isForRfq: boolean;
  paragraphs: JobSpecTemplateParagraphDto[];
  version: EntityVersion;
  status: SpecTemplateStatus;
};

export type JobSpecTemplateParagraphBaseDto = {
  name: string;
  text: string;
  paragraphIs: SpecTemplateParagraphIs;
  textIs: SpecTemplateTextIs;
  isTextWarning: boolean;
};
export type JobSpecTemplateParagraphDto = JobSpecTemplateParagraphBaseDto & {
  specTemplateParagraphId: ID;
  sections: JobSpecTemplateSectionDto[];
};

export type JobSpecTemplateSectionBaseDto = {
  name: string;
  text: string;
  sectionIs: SpecTemplateSectionIs;
  textIs: SpecTemplateTextIs;
  isTextWarning: boolean;
};
export type JobSpecTemplateSectionDto = JobSpecTemplateSectionBaseDto & {
  specTemplateSectionId: ID;
  clausesAre: SpecTemplateClauses;
  clauses: JobSpecTemplateClauseDto[];
};

export type JobSpecTemplateClauseDto = {
  text: string;
  isTextWarning: boolean;
};
